import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ApplicationProfileState } from '@app/resources/ngrx/states';

export const selectApplicationProfileState = createFeatureSelector<ApplicationProfileState>('applicationProfile');
export const selectApplicationProfile = createSelector(selectApplicationProfileState, (state) => state.profile);
